import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // name when click settting hospital
    hospitalName: '',
    backGroundUploads: [], // ใช้สำหรับเก็บข้อมูลการ upload แบบ Background
    userInfo: {
      user_id: '',
      first_name: '',
      last_name: '',
      phone: '',
      gender: '',
      image: '',
      date_of_birth: '',
      permissions: [
        // {
        //   permission_id: '',
        //   name: '',
        //   description: '',
        //   priority: 0
        // }
      ],
      verify: 0,
      street: '',
      zip_code: '',
      city: '',
      country_code: '',
      country: '',
      description: '',
      methods: [
        // {
        //   provider: 'local',
        //   method_id: '',
        //   email: '',
        //   username: ''
        // }
      ],
      name_title: ''
    },
    currentProjectMenus: [], // NOTE สำหรับเก็บข้อมูล Menu ทั้งหมดของ Project เมื่อกดเข้า Project
    currentOption: '' // NOTE สำหรับเก็บว่ากด Tab ไหนอยู่ในโรงพยาบาล

  },
  getters: {
    getUploadBackground: (state) => {
      // TODO เป็น function ในการดึงข้อมูล Background Upload
      return state.backGroundUploads
    },
    storeGetUserInfo (state) {
      // TODO สำหรับ Get User Info
      return state.userInfo
    },
    storeGetProjectMenus (state) {
      return state.currentProjectMenus
    },
    storeGetCurrentOption (state, newData) {
      return state.currentOption
    }
  },
  mutations: {
    hospitalName (state, newData) {
      state.hospitalName = newData
    },
    addUploadBackground (state, val) {
      // state.backGroundUploads = [...val, ...state.backGroundUploads]
      state.backGroundUploads = val
    },
    storeSetUserinfo (state, newData) {
      // TODO สำหรับ Set User Info
      state.userInfo = { ...state.userInfo, ...newData }
    },
    storeSetProjectMenus (state, newData) {
      state.currentProjectMenus = newData
    },
    storeSetCurrentOption (state, newData) {
      state.currentOption = newData
    }

  },
  actions: {
    clearProjectMenus (context) {
      // TODO เป็น Function สำหรับ Clear Value Option ของ Menu ในโรงพยาบาล
      context.commit('storeSetProjectMenus', [])
      context.commit('storeSetCurrentOption', [])
    }

  },
  modules: {}
})
